const subtitle = {
  orders:
    'Step 1 of 3 — what you ordered. Add manual orders here if they didn’t go through OMS.',
  receipting:
    'Step 2 of 3 — what arrived. Fix shortages and damage here, then Full accept.',
  invoices:
    'Step 3 of 3 — match supplier invoices to your OMS orders and reconcile.',
  creditnotes:
    'Track open credit requests and mark them resolved when the supplier settles.',
  'product-issues':
    'Catalogue data errors reported from products, orders, and invoices — track through to resolved.',
  ordered: 'Everything you need to know about the products you’re buying.',
  spendTime: 'Monitor your supplier spending and check your monthly outgoings',
  credit: 'Check your credit balance and keep track of your credit statements.',
  statement: 'Overview of your purchasing activity.',
  'gross-profit': 'See how purchasing affects your gross profit.',
}

const getSubtitle = slug => subtitle[slug] || ''

export default getSubtitle
